const pt = {
  nav: {
    howItWorks: "Como funciona",
    fees: "Taxas",
    corridors: "Corredores",
    security: "Segurança",
    press: "Imprensa",
    faq: "FAQ",
    contact: "Contato",
    joinWaitlist: "Lista de espera",
    joinWaitlistLong: "Entrar na lista de espera",
    openMenu: "Abrir menu",
    language: "Idioma",
  },
  hero: {
    eyebrow: "Embarque · Lista de espera aberta",
    tag: "v1.0 — beta privado em corredores selecionados",
    line1: "Envie",
    line2: "num toque.",
    line3: "África \u2194 mundo.",
    subhead:
      "O Instantxfer CashApp move dinheiro entre a África e o resto do mundo em minutos — com as menores taxas, câmbio mid-market em tempo real e pagamento para banco, mobile money, retirada em dinheiro ou identificador scan-to-pay.",
    ctaWaitlist: "Acesso antecipado",
    ctaHow: "Ver uma transferência",
    trust: {
      settleLabel: "Liquidação mediana",
      feeLabel: "Taxa total de transferência*",
      countriesLabel: "Países no lançamento",
      feeNote: "*taxa mid-market, sem spread cambial oculto",
      backedBy: "Apoiado por parceiros de pagamento regulados em 34 mercados",
    },
  },
  liveQuote: {
    eyebrow: "Cotação ao vivo",
    liveMid: "ao vivo · mid-market",
    youSend: "Você envia",
    receive: "Eles recebem",
    fee: "Taxa",
    corridor: "Corredor",
    getRate: "Travar esta taxa",
  },
  corridors: {
    eyebrow: "Corredores disponíveis",
    headline: "Taxas de câmbio competitivas",
    headlineItalic: "em cada transferência.",
    intro: "O Instantxfer CashApp está atualmente disponível nestes países.",
    introHighlight: " Mais em breve.",
    mostRequested: "Mais pedidos",
    active: "Ativos",
    comingSoon: "Em breve",
    activePill: "Ativo",
    soonPill: "Em breve",
    votedPill: "Votado",
    tapToVote: "Toque num país «em breve» para votar",
    sentToday: "enviados hoje",
    votes: "votos",
    notSeeing: "Não vê um corredor de que precisa?",
    requestIt: "Peça-o",
    requestTail: " — os mais votados são construídos primeiro.",
    footer: "Taxas ao vivo · mid-market · 0,9\u00A0% fixa",
    you: "Você",
  },
  waitlist: {
    eyebrow: "Acesso antecipado",
    title: "Reserve seu identificador,",
    italic: "trave taxas vitalícias.",
    body: "O Instantxfer CashApp está sendo implantado um corredor por vez. Membros do Círculo Fundador ganham preço vitalício de 0,5\u00A0%, limites de pagamento prioritários e a primeira escolha dos identificadores scan-to-pay.",
    formTitle: "Entrar no beta privado",
    email: "E-mail",
    emailPlaceholder: "voce@empresa.com",
    fullName: "Nome completo (opcional)",
    fullNamePlaceholder: "Seu nome",
    corridor: "Seu corredor principal",
    submit: "Reservar minha vaga",
    submitting: "Reservando…",
    already: "Você já está na lista.",
    successTitle: "Você está na lista.",
    successBody: "Confira seu e-mail — acabamos de enviar uma confirmação com as taxas mid-market de hoje.",
    founderTitle: "Você é fundador.",
    founderBody: "Confira seu e-mail — uma nota pessoal do fundador está a caminho com seus benefícios vitalícios.",
    error: "Algo deu errado. Tente novamente em instantes.",
    invalidEmail: "Digite um e-mail válido.",
    privateBeta: "Beta privado · Vagas limitadas",
    skipQueue1: "Pule a fila",
    skipQueue2Italic: "em dois campos.",
    membersLine: "Membros iniciais travam taxas vitalícias mais baixas, limites de pagamento prioritários e acesso antecipado ao identificador scan-to-pay. Sem cartão necessário.",
    founderLive: "Fundador 100 · ao vivo",
    seatsTaken: "ocupadas",
    seatsFillLive: "Vagas preenchem em tempo real",
    seatsLeft: "restantes",
    referredBy: "Indicado por",
    skipQueueTag: "· você pula a fila",
    quoteLabel: "Sua cotação:",
    quoteCta: "Reserve sua vaga para enviar de verdade — pré-selecionamos seu corredor.",
    nudgeTitle: "Não sabe por onde começar? Experimente a calculadora →",
    nudgeBody: "Veja taxas ao vivo do seu corredor, depois volte para reservar sua vaga.",
    inviteLink: "Seu link de convite",
    bringFriend: "Traga um amigo · um passe grátis",
    copy: "Copiar",
    copied: "Copiado",
    share: "Compartilhar",
    inviteFootnote: "Qualquer pessoa que entrar pelo seu link pula a fila. Enquanto houver vagas, ela também se torna fundadora.",
    openFounderCircle: "Abrir Círculo Fundador",
    agreeTerms: "Ao entrar você concorda com nossos",
    and: "e nossa",
    noSpam: ". Zero spam, nunca.",
    terms: "termos",
    privacy: "privacidade",
  },
  footer: {
    ctaEyebrow: "Envie dinheiro como uma mensagem",
    ctaTitle: "A África e o mundo,",
    ctaTitleItalic: "a dois toques de distância.",
    ctaBtn: "Acesso antecipado",
    colProduct: "Produto",
    colCompany: "Empresa",
    colLegal: "Legal",
    colReach: "Contato",
    linkFounders: "Círculo Fundador",
    linkAbout: "Sobre",
    linkPress: "Imprensa",
    terms: "Termos de serviço",
    privacy: "Privacidade",
    amlKyc: "AML / KYC",
    cookies: "Cookies",
    systemsNominal: "Sistemas nominais",
    rights: "Todos os direitos reservados.",
    chatWhatsApp: "Fale conosco no WhatsApp",
  },
  contact: {
    whatsApp: "WhatsApp",
    whatsAppNote: "Fundadores respondem em menos de uma hora · 09h00–20h00 WAT",
    chatWhatsApp: "Fale conosco no WhatsApp",
  },
  foundersVideo: {
    eyebrow: "Conheça o fundador",
    title: "Um olá de 30 segundos",
    italic: "de Phil-Kholynes.",
    body: "Por que estamos construindo o Instantxfer CashApp, para quem ele é, e quais corredores vamos ligar em seguida. Direto do fundador.",
    comingSoon: "Vídeo chegando em breve",
    duration: "0:30",
    playAria: "Reproduzir o vídeo de introdução do fundador",
  },
  launchToast: {
    eyebrow: "Corredor · agora ao vivo",
    headline: "Você pediu. {{country}} está no ar.",
    body: "Taxas mid-market, mobile money + trilhos bancários — ao vivo a partir de hoje em {{country}}.",
    cta: "Envie sua primeira transferência",
    dismiss: "Fechar",
  },
  about: {
    seoTitle: "Sobre · Quatro fundadores, uma missão — Instantxfer CashApp",
    seoDescription: "Conheça os quatro fundadores que constroem o WhatsApp do dinheiro internacional. Retratos, história e os valores impressos em cada recibo.",
    hero: {
      eyebrow: "Os fundadores",
      title: "Quatro pessoas,",
      italic: "um livro de retratos.",
      body: "Criamos o Instantxfer CashApp porque enviar dinheiro para casa não deveria parecer implorar a um banco. Conheça o time por trás do recibo.",
    },
    photobook: {
      eyebrow: "Retratos · Círculo Fundador",
      title: "As pessoas que assinaram",
      italic: "o manifesto.",
      body: "Cada compromisso do manifesto é assinado por esses quatro. Nenhum deck de conselho substitui isso.",
      captionRole: "Função",
      captionCity: "Cidade",
      captionSince: "Conosco desde",
      share: "Compartilhar retrato",
      shareCopied: "Link copiado",
    },
    timeline: {
      eyebrow: "Notas de campo · A história fundadora",
      title: "De uma ideia",
      italic: "a mil remetentes.",
      body: "Não é um keynote. É um conjunto cronológico de recibos, na ordem em que aconteceram.",
      chapters: [
        {
          date: "Fev. 2024",
          tag: "A ideia",
          title: "Duas transferências, uma ligação de domingo.",
          body: "Phil-Kholynes envia mensalidade escolar para Enugu num domingo. Três bancos, quarenta e sete minutos, £34 perdidos. Na manhã seguinte, um Notion compartilhado chamado «instantxfer.md» tem 14 bullets e uma linha de manifesto.",
        },
        {
          date: "Abr. 2024",
          tag: "Primeiro protótipo",
          title: "Uma calculadora que dizia a verdade.",
          body: "A equipe lança um widget de envio estático que mostra o câmbio mid-market — sem spread, sem custo de wire. É feio. É correto. Isso é o que importa.",
        },
        {
          date: "Ago. 2024",
          tag: "Primeira transferência",
          title: "£100 → ₦168.900, 42 segundos.",
          body: "A primeira transferência ao vivo cai na conta GTBank da mãe de Adaeze antes do chá dela terminar de infundir. O recibo está colado na geladeira. Ainda está.",
        },
        {
          date: "Nov. 2024",
          tag: "Os primeiros cem",
          title: "O Círculo Fundador abre.",
          body: "Cem crentes se inscrevem em nove dias. Cada um recebe um bilhete manuscrito e uma vaga vitalícia de 0,5\u00A0%. Os nomes ficam no ranking, para sempre.",
        },
        {
          date: "Mar. 2026",
          tag: "Os primeiros mil",
          title: "Corredores abertos em quatro continentes.",
          body: "Dezessete corredores ativos. Câmbio mid-market ao vivo. Mobile money + banco + identificador scan-to-pay. Mil remetentes movendo dinheiro como uma mensagem. O Canadá entra no mapa.",
        },
        {
          date: "Agora",
          tag: "O lançamento público",
          title: "Você, a seguir.",
          body: "Beta privado aberto, vagas do Fundador 100 se enchendo rápido. Todos os compromissos do manifesto continuam válidos. Os recibos seguem sendo impressos.",
        },
      ],
    },
    manifestoNote: "Assinado pelos quatro, impresso em cada recibo.",
  },
  rateAlert: {
    eyebrow: "Alertas de taxa",
    headline: "Seja avisado quando",
    headlineItalic: "mover 1\u00A0%",
    headlineTail: "a seu favor.",
    body: "Um e-mail, apenas quando a taxa estiver realmente melhor. Sem spam, cancele em um toque.",
    submit: "Me avise quando mover",
    sending: "Enviando…",
    successTitle: "Está feito.",
    alreadyTitle: "Você já está inscrito.",
    successBody: "Vamos avisar {{email}} quando {{from}} → {{to}} mover pelo menos 1\u00A0%.",
    errorRetry: "Tente novamente.",
    errorNet: "Falha de rede. Tente em um instante.",
  },
  rateLock: {
    eyebrow: "Taxa travada · 24h de recompensa",
    headline: "Trave",
    headlineItalic: "a taxa de hoje",
    headlineTail: "por 24 horas.",
    body: "Como incentivo de inscrição, honramos a taxa mid-market de hoje na sua primeira transferência — mesmo se o mercado se voltar contra nós. Um e-mail, uma trava, zero taxa escondida.",
    submit: "Travar esta taxa",
    submitting: "Travando…",
    successTitle: "Taxa travada.",
    alreadyTitle: "Você já travou esta taxa.",
    lockedAt: "Você travou",
    goodUntil: "Válida até",
    finishSignup: "Finalizar inscrição",
    errorRetry: "Tente novamente.",
    errorNet: "Falha de rede. Tente em um instante.",
    countdown: "Trava expira em",
    share: "Compartilhar minha trava",
    downloadCard: "Baixar cartão",
    days: "d",
    hours: "h",
    minutes: "m",
    seconds: "s",
    leaderboard_one: "{{count}} taxa travada nas últimas 24h",
    leaderboard_other: "{{count}} taxas travadas nas últimas 24h",
  },
  cookies: {
    heading: "Usamos",
    headingItalic: "alguns.",
    body: "Usamos alguns cookies para lembrar de você e melhorar o site. Sem anúncios, sem rastreio de terceiros.",
    acceptAll: "Aceitar tudo",
    onlyEssential: "Apenas essenciais",
    privacy: "Política de privacidade",
  },
  common: {
    live: "Ativo",
    soon: "Em breve",
    watchCorridor: "Acompanhar corredor",
    open: "Abrir corredor",
    close: "Fechar",
  },
  home: {
    trust: { eyebrow: "Ligado aos trilhos", body: "Parcerias diretas de pagamento em cada corredor — sem banco correspondente no meio." },
    send: { eyebrow: "Experimente antes de instalar", title: "O número exato,", italic: "antes de você tocar em enviar." },
    manifesto: { eyebrow: "O manifesto", headline: "Seis compromissos, impressos no recibo.", chaptersLabel: "Capítulos", tag: "Escrito à mão · assinado pelos quatro fundadores", items: [
      { title: "Taxa que cabe em uma linha.", body: "0,9\u00A0% fixa. Sem spread de wire. Sem margem cambial oculta. O que você envia é o que eles recebem — impresso no comprovante antes de você tocar." },
      { title: "Minutos, não dias úteis.", body: "Trilhos diretos para mobile money e redes bancárias em 34 países. A maioria dos transferências liquida em menos de três minutos." },
      { title: "Um identificador para tudo.", body: "@philKholynes.instant funciona em todo lugar. Banco, carteira, retirada em dinheiro — ou um QR EMVCo escaneado numa loja de esquina em Kigali." },
      { title: "Família em primeiro, finança em segundo.", body: "Suporte recorrente, dividir com irmãos, pagar escola direto, recarga de celular — desenhado para o jeito que remessa acontece de verdade." },
      { title: "Regulado onde importa.", body: "Parceiros licenciados nos dois lados. KYC que respeita seu tempo — três campos, noventa segundos, uma foto." },
      { title: "Feito para o próximo bilhão.", body: "Performance nativa iOS, recibos offline, modo de baixa banda e suporte em nove idiomas incluindo iorubá, suaíli e amárico." },
    ]},
    corridorMap: { eyebrow: "Corredores · 34 países" },
    payout: { eyebrow: "Formas de pagamento", title: "Entregue o dinheiro", italic: "do jeito que a vida pede." },
    handle: { eyebrow: "Scan · Envio · Liquidação", title: "Um identificador.", italic: "Em todo lugar." },
    leaderboard: { eyebrow: "Ranking dos fundadores", title: "Os primeiros cem", italic: "que acreditaram em nós." },
    comparison: { eyebrow: "A conta", title: "O que você economiza,", italic: "aparece em verde." },
    editorial: { eyebrow: "Notas de campo", title: "A história das remessas,", italic: "à medida que a reescrevemos." },
    security: { eyebrow: "Segurança & conformidade", title: "Sólido como um banco,", italic: "leve como uma mensagem." },
    appStore: { eyebrow: "Chega no 2\u00BA trimestre de 2026", title: "iOS & Android,", italic: "no mesmo dia." },
    qrInstall: { eyebrow: "Escaneie para instalar", title: "Aponte o celular.", italic: "Envie.", subtitle: "Escaneie com o celular" },
  },
  pageHero: {
    howItWorks: {
      eyebrow: "Como funciona",
      title: "Envie dinheiro como uma mensagem.",
      italic: "Chega antes da sua resposta.",
      body: "Quatro passos, um toque. O Instantxfer CashApp liquida transferências internacionais entre a África e o mundo em minutos — menores taxas, câmbio mid-market ao vivo, pagamento para banco, mobile money, retirada em dinheiro ou identificador scan-to-pay.",
    },
    fees: {
      eyebrow: "Taxas",
      title: "Uma taxa única de 0,9\u00A0%.",
      italic: "Sem spread cambial oculto.",
      body: "Cobramos uma única taxa honesta — 0,9\u00A0% da transferência — sobre a taxa mid-market real. Membros do Fundador 100 travam 0,5\u00A0% vitalício.",
    },
    countries: {
      eyebrow: "Corredores",
      title: "17 corredores ativos.",
      italic: "Mais 40 em breve.",
      body: "O Instantxfer CashApp está disponível nestes países. Vote no corredor que você precisa — os mais pedidos são construídos primeiro.",
    },
    security: {
      eyebrow: "Segurança",
      title: "Segurança de nível bancário,",
      italic: "cuidado em escala humana.",
      body: "Parceiros de pagamento regulados em 34 mercados. Criptografia ponta-a-ponta. Autenticação multifator por padrão. Seu dinheiro fica em contas segregadas.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Tudo que você precisa saber",
      italic: "para nos confiar seu dinheiro.",
      body: "Respostas curtas às perguntas mais frequentes de fundadores, remetentes e imprensa.",
    },
    contact: {
      eyebrow: "Contato",
      title: "Diga olá.",
      italic: "Respondemos em 24\u00A0h.",
      body: "Imprensa, parcerias, perguntas do dia a dia. Fale diretamente com a equipe fundadora — sem fila de tickets, sem bot.",
    },
    press: {
      eyebrow: "Imprensa · sala de sinais",
      title: "Tudo o que um jornalista",
      italic: "precisa em menos de um minuto.",
      body: "Biografias dos fundadores, ativos de marca, prévias do digest semanal e uma linha direta com a equipe.",
    },
    founders: {
      eyebrow: "Círculo Fundador",
      title: "Os primeiros cem",
      italic: "que acreditaram em nós.",
      body: "Membros do Fundador 100 ganham 0,5\u00A0% vitalício, limites de pagamento prioritários e a primeira escolha dos identificadores scan-to-pay.",
    },
    waitlist: {
      eyebrow: "Acesso antecipado",
      title: "Reserve seu identificador,",
      italic: "trave taxas vitalícias.",
      body: "O Instantxfer CashApp está sendo implantado um corredor por vez. Membros do Círculo Fundador ganham preço vitalício de 0,5\u00A0%, limites de pagamento prioritários e a primeira escolha dos identificadores scan-to-pay.",
    },
    terms: { eyebrow: "Legal", title: "Termos de serviço.", italic: "Em linguagem clara.", body: "As regras que regem seu uso do Instantxfer CashApp." },
    privacy: { eyebrow: "Legal", title: "Aviso de privacidade.", italic: "Seus dados, suas regras.", body: "O que coletamos, por quê, e como pedir para apagarmos." },
    aml: { eyebrow: "Conformidade", title: "AML & KYC.", italic: "Como mantemos a rede limpa.", body: "As verificações de identidade, origem de fundos e monitoramento que protegem a plataforma." },
    cookies: { eyebrow: "Legal", title: "Cookies.", italic: "O mínimo necessário.", body: "Os cookies essenciais que usamos e as análises que nos ajudam a construir melhor." },
  },
  content: {
    howItWorks: {
      steps: [
        {
          title: "Verifique em 90 segundos",
          body: "Foto do documento e um selfie. O motor KYC do Instantxfer CashApp confirma sua identidade — geralmente antes da sua chaleira ferver.",
          detail: ["Passaporte, CNH ou RG", "Verificação automática de vivacidade", "Cofre biométrico sem conhecimento"],
        },
        {
          title: "Adicione seu pessoal",
          body: "Banco, carteira ou identificador — escolha o trilho mais rápido. Salve o destinatário uma vez, reuse para sempre com Face-ID.",
          detail: ["M-Pesa · MoMo · Orange · Airtel", "Banco via routing / IBAN / GT#", "@identificador.instant em todas as redes"],
        },
        {
          title: "Envie com o valor exato",
          body: "Veja o câmbio mid-market, a taxa e o que eles receberão — até o centavo — antes de tocar em enviar. Sem spread, sem surpresa.",
          detail: ["Câmbio mid-market ao vivo", "0,9\u00A0% fixa, divulgada antes", "Trava opcional de 24 horas"],
        },
        {
          title: "Veja o dinheiro chegar",
          body: "Mediana abaixo de três minutos para mobile money, bancos ou retirada em agente. Você recebe um comprovante com link compartilhável.",
          detail: ["Rastreamento em tempo real", "Confirmação SMS + push", "Suporte humano 24/7 no beta"],
        },
      ],
    },
    fees: {
      note: "Preços exibidos são ilustrativos. Tarifas do Círculo Fundador se aplicam no primeiro ano e exigem inscrição durante o beta privado.",
      tiers: [
        { name: "Pessoal", priceNote: "fixa, por envio", features: ["Até 10.000\u00A0$ / mês", "Banco + mobile money + QR", "Câmbio mid-market ao vivo", "Suporte 24/7"], cta: "Entrar na lista" },
        { name: "Círculo Fundador", priceNote: "no primeiro ano", features: ["Apenas os 5.000 primeiros", "Pagamento prioritário até 50\u00A0mil$ / mês", "Linha direta com fundadores", "Acesso antecipado ao scan-to-pay"], cta: "Reservar vaga" },
        { name: "Empresas", priceNote: "preço personalizado", features: ["Descontos por volume a partir de 50\u00A0mil$ / mês", "Perfis multi-usuário + auditoria", "API + webhooks", "Gerente de conta dedicado"], cta: "Falar com vendas" },
      ],
    },
    security: {
      controls: [
        { title: "Cofre-forte, ligado ao aparelho", body: "Tokens de sessão são vinculados ao aparelho físico via Secure Enclave / StrongBox. Todo pagamento é assinado no aparelho antes de sair." },
        { title: "Sincronização sem conhecimento", body: "Seus contatos e histórico são criptografados com chaves que não podemos ler. Se nosso banco vazasse, o atacante veria apenas ruído." },
        { title: "Motor antifraude 3D", body: "Cada envio é pontuado por sinais de aparelho, comportamento e rede. Anomalias pausam o envio e acionam revisão humana — em segundos." },
        { title: "Trilha de auditoria em cada trilho", body: "Logs imutáveis e assinados em todos os parceiros de pagamento. Reconciliação contínua — não uma vez por dia às 4h." },
        { title: "Regulado, não rebelde", body: "O Instantxfer CashApp trabalha com instituições de pagamento licenciadas em cada corredor. Fundos ficam em contas segregadas em bancos Tier-1." },
        { title: "Divulgação coordenada", body: "Divulgação coordenada com programa de bug bounty permanente. Pesquisadores de segurança bem-vindos — security@instantxfer.com." },
      ],
    },
    faq: {
      items: [
        { q: "Quão rápida é uma transferência, de verdade?", a: "A liquidação mediana é abaixo de três minutos para mobile money e grandes bancos na Nigéria, Quênia, Gana, Uganda, Ruanda, Senegal, Costa do Marfim e África do Sul. Bancos menores podem levar até 30 minutos, dependendo das janelas da rede destinatária." },
        { q: "Quanto custa realmente o Instantxfer CashApp?", a: "0,9\u00A0% do valor enviado, calculado no mid-market. Sem spread, sem taxa de wire, sem mensalidade. Corredores com retirada em dinheiro têm uma pequena taxa de agente (1–3\u00A0$) que exibimos com antecedência." },
        { q: "Quais redes de mobile money vocês suportam?", a: "M-Pesa (Quênia, Tanzânia), MTN MoMo (Gana, Nigéria, Uganda, Ruanda, Zâmbia, Costa do Marfim, Benin), Orange Money (Senegal, Costa do Marfim, Mali), Airtel Money (Uganda, Zâmbia, Malaui), Wave (Senegal, Costa do Marfim), Telebirr (Etiópia), além de várias carteiras regionais." },
        { q: "O que é o identificador scan-to-pay?", a: "Seu identificador Instantxfer CashApp (@seunome.instant) é uma identidade de pagamento portátil. Imprima, compartilhe num chat ou aponte o QR EMVCo de um lojista — o dinheiro liquida instantaneamente, sem cartão ou número de conta." },
        { q: "Como vocês ganham dinheiro com taxa tão baixa?", a: "Liquidamos em lote em trilhos diretos e ficamos com uma pequena margem no fluxo — nunca no câmbio. Conforme escalamos, a economia melhora e devolvemos aos membros do Círculo Fundador." },
        { q: "Meu dinheiro está seguro?", a: "Os fundos ficam em contas segregadas em bancos Tier-1. O Instantxfer CashApp trabalha com instituições licenciadas em cada corredor. Os saldos são cobertos até o limite regulatório aplicável na sua jurisdição." },
        { q: "Que documento preciso para o KYC?", a: "Foto do passaporte, RG ou CNH, mais um selfie rápido. A verificação leva em geral menos de 90 segundos. Contas empresariais exigem documentos corporativos e divulgação de beneficiários." },
        { q: "Vocês suportam crypto?", a: "Não no lançamento. Podemos adicionar trilhos stablecoin opcionais para liquidação inter-corredor — mas o produto para o consumidor continua sendo fiat, mobile money e transferência bancária." },
        { q: "Quando o Instantxfer CashApp é lançado?", a: "O beta privado vai primeiro aos membros do Círculo Fundador. O lançamento público segue em corredores selecionados — entre na lista de espera para receber seu convite." },
      ],
    },
  },
};

export default pt;
